import { MutableType, OperationType } from "actions/mutate";
import { ALLOCATION_BAG_ID, ITEMS_ID } from "constants/product-collection";
import { isAllocationDimensionsObjectId } from "./collection";

// TODO Performance: Add unit test & operations type
export const shouldRecalculateTotals = (objectId: string, sessionId: string, operations: any[]) => {
    let majorOperations = false;
    if (objectId === ITEMS_ID) {
        // Re-calculate the whole grid in these cases:
        // - peer is making change
        // - row is removed
        // - row is inserted
        majorOperations = operations.some((operation) => {
            const isPeerOperation = operation.session_id !== sessionId;
            const isListInsertOrRemove =
                operation.mutable_type === MutableType.List &&
                operation.operations.some((subOperation) => {
                    // Noop can be sent by server...check for this
                    if (!subOperation.mutable_list_operation) {
                        return false;
                    }
                    return (
                        !!subOperation.mutable_list_operation[OperationType.Insert] ||
                        !!subOperation.mutable_list_operation[OperationType.Remove]
                    );
                });

            return isPeerOperation || isListInsertOrRemove;
        });
    } else if (isAllocationDimensionsObjectId(objectId) || objectId === ALLOCATION_BAG_ID) {
        majorOperations = true;
    }

    return majorOperations;
};
